const DETAIL_QUESTION = {
    questions: [],
}
export const ASSESSMENT_QUESTIONS = {
    mandatory: undefined,
    questions: [],
}

export const JOB_DETAILS = {
    job_info: {},
    people_in_company_overview: "",
    working_hour_info: {},
    job_assessment_info: {},
    is_nearby_location: null,
    ecc_response_message: "",
    is_creator_internal: null,
    is_creator_consultant: null,
    consultancy_name: "",
    candidate_eligibility: {},
    assessment_info: {},
}

export const SCREEN_DETAILS = {
    cta: { type: "", text: "" },
    icon_url: "",
    title: "",
    sub_title: "",
    body: "",
    lower_text: "",
    application_id: null,
}

export const EVAL_ASSESSMENT = {
    verdict: null,
    assessment_results: { assessment_status: "", client_strings: {} },
    assessment_throttling_info: {
        max_attempts: null,
        throttling_days: null,
        throttle_assessment: null,
        attempts_in_throttling_days: null,
    },
}
